export const DEFAULT_BROTHER_AVATAR = 'https://jlucsghffgpjtcitotco.supabase.co/storage/v1/object/public/avatars/brother/6f21c43f-4cb4-44dc-9397-f9917f11917a.png';
export const DEFAULT_SISTER_AVATAR = 'https://jlucsghffgpjtcitotco.supabase.co/storage/v1/object/public/avatars/sister/c1558bc1-80d8-4e46-9ef1-a4d2ee3402ed.png';

export const defaultAvatar = (gender) =>
  gender === 'sister' ? DEFAULT_SISTER_AVATAR : DEFAULT_BROTHER_AVATAR;
